import { getReq, putReq, createUrl } from "@/infra/http";
import { BaseResponseModel } from "@/models/core.model";
import { UserSetting, UpdateUserSetting } from "@/models/user-setting.model";

export const getUserSetting = async (userId: number): Promise<BaseResponseModel<UserSetting>> => {
  return await getReq(createUrl(`/a/UserSetting/GetByUserId/${userId}`),
  ).then((res: any) => res.data);
};

export const updateUserSetting = async (input: UpdateUserSetting): Promise<BaseResponseModel<UserSetting>> => {
  return await putReq(createUrl("/a/UserSetting/Update"),
    input
  ).then((res: any) => res.data);
};